import {FieldError, GuestGroup, PhoneDetails, SelectOption} from '@chekin/core';
import {
  AgreementClauseKeyFormName,
  AGREEMENT_CLAUSE_FIELDS,
  LOCATIONS_FIELDS,
  SELECT_FIELDS,
  PHONE_FIELDS,
  DATE_FIELDS,
} from './constants';

const isSelectField = (value: unknown): value is (typeof SELECT_FIELDS)[number] => {
  return SELECT_FIELDS.includes(value as (typeof SELECT_FIELDS)[number]);
};

const isPhoneField = (value: unknown): value is (typeof PHONE_FIELDS)[number] => {
  return PHONE_FIELDS.includes(value as (typeof PHONE_FIELDS)[number]);
};

const isLocationField = (value: unknown): value is (typeof LOCATIONS_FIELDS)[number] => {
  return LOCATIONS_FIELDS.includes(value as (typeof LOCATIONS_FIELDS)[number]);
};

const isDateField = (value: unknown): value is (typeof DATE_FIELDS)[number] => {
  return DATE_FIELDS.includes(value as (typeof DATE_FIELDS)[number]);
};

const isAgreementClauseField = (fieldName: string) => {
  return AGREEMENT_CLAUSE_FIELDS.includes(
    fieldName as (typeof AGREEMENT_CLAUSE_FIELDS)[number],
  );
};

const isSelectOptionTypeValid = (value: unknown): value is SelectOption => {
  return Boolean((value as SelectOption)?.value && (value as SelectOption)?.label);
};

const isPhoneNumberTypeValid = (value: unknown): value is PhoneDetails => {
  return Boolean((value as PhoneDetails)?.number && (value as PhoneDetails)?.code);
};

const buildAgreementClausesFormData = (clauses: Record<string, boolean>) => {
  return Object.entries(clauses).reduce((accumulator, [id, value]) => {
    accumulator[`${AgreementClauseKeyFormName}${id}`] = value;
    return accumulator;
  }, {} as Record<string, boolean>);
};

const hasAnotherLeaderGuest = (guestGroup?: GuestGroup | undefined) => {
  if (!guestGroup?.leader_id) return false;
  return guestGroup.members.some(member => member.id === guestGroup.leader_id);
};

const DUPLICATE_PRE_REGISTERED_GUEST_ERROR_CODE = 'duplicate_pre_registered_guest';

const isDuplicatePreRegisteredGuestError = (errors?: FieldError[]): boolean => {
  if (!errors?.length) return false;

  return errors.some(({code}) => code === DUPLICATE_PRE_REGISTERED_GUEST_ERROR_CODE);
};

export {
  isSelectField,
  isPhoneField,
  isLocationField,
  isDateField,
  isSelectOptionTypeValid,
  isPhoneNumberTypeValid,
  isAgreementClauseField,
  buildAgreementClausesFormData,
  hasAnotherLeaderGuest,
  isDuplicatePreRegisteredGuestError,
  DUPLICATE_PRE_REGISTERED_GUEST_ERROR_CODE,
};
